import { createTheme, Shadows } from '@mui/material/styles';
import { lightBlue, red, teal, grey } from '@mui/material/colors';

const shadows = ['none', ...Array.from(Array(24)).map((_, i) => `0 0 ${i + 12}px 0 rgba(0, 0, 20, 0.15)`)] as Shadows;

const theme = createTheme({
  typography: {
    fontSize: 16,
    fontFamily: [
      'Nanum Myeongjo',
      'serif',
      // 'Noto Sans',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: grey.A700,
    },
    secondary: {
      main: lightBlue.A200,
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#FAF8F5',
    },
  },
  shape: {
    borderRadius: 2.5,
  },
  shadows,
});

export default theme;
